import {
  campaignUpdateSchema,
  populatedCampaignSchema,
  type PopulatedCampaign,
} from "@redotech/redo-model/campaigns/campaign-definition";
import type { z } from "zod";

export const updateCampaign = {
  input: campaignUpdateSchema,
  output: populatedCampaignSchema as z.ZodType<PopulatedCampaign>, // type too big to infer
};
